import React from "react";
import { Switch } from "react-router-dom";

import Public from "./public";
import Private from "./private";

import Portal from "../components/portal";
import Landing from "../components/landing";

const Routes = () => {
  return (
    <Switch>
      <Private path="/dashboard" render={(props) => <Portal {...props} />} />
      <Public path="/" component={Landing} />
    </Switch>
  );
};

export default Routes;
